"use client";

import { ArrowLeft, Home, Search } from "lucide-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  BattlefieldCard,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function NotFound() {
  return (
    <div className="battlefield-bg-pattern relative min-h-screen overflow-hidden bg-gradient-to-br from-background via-background/95 to-muted/20">
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden opacity-30">
        <div className="battlefield-grid absolute inset-0" />

        {/* Scanning lines effect */}
        <div className="absolute left-0 h-px w-full animate-pulse bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
      </div>

      <div className="container relative mx-auto flex min-h-screen items-center justify-center px-4">
        <BattlefieldCard className="battlefield-border w-full max-w-lg">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
              <Search className="h-10 w-10 text-primary" />
            </div>
            <CardTitle className="font-heading text-3xl">
              LOCATION NOT FOUND
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-center">
            <div className="space-y-3">
              <p className="font-body text-lg text-muted-foreground">
                The requested tactical coordinates could not be located in our
                database.
              </p>
              <p className="font-body text-muted-foreground text-sm">
                The page you're looking for might have been moved, deleted, or
                never existed.
              </p>
            </div>

            <div className="space-y-3">
              <Button asChild className="battlefield-button w-full" size="lg">
                <Link href="/">
                  <Home className="mr-2 h-5 w-5" />
                  Return to Base
                </Link>
              </Button>

              <div className="grid grid-cols-2 gap-2">
                <Button
                  className="w-full"
                  onClick={() => window.history.back()}
                  variant="outline"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Go Back
                </Button>
                <Button asChild className="w-full" variant="outline">
                  <Link href="/loadouts">
                    <Search className="mr-2 h-4 w-4" />
                    Loadouts
                  </Link>
                </Button>
              </div>
            </div>

            <div className="border-t pt-6">
              <div className="space-y-2">
                <p className="font-heading text-primary text-xs uppercase tracking-wider">
                  [ ERROR CODE: 404 ]
                </p>
                <p className="font-body text-muted-foreground text-xs">
                  BF6 Loadouts Navigation System
                </p>
                <p className="font-body text-muted-foreground text-xs">
                  Target location not in tactical database
                </p>
              </div>
            </div>
          </CardContent>
        </BattlefieldCard>
      </div>
    </div>
  );
}
